<template>
    <pm-app-component hide-sidebar>
        <template slot="mobile-toolbar">
            <pm-application-bar simple>
                {{ $t('menu.pricelist') }} ({{ $store.state.currency }})
            </pm-application-bar>
        </template>

        <v-container v-if="!loading">

            <template v-for="i in ['2','7','1','6','3','5']">
                <div v-if="groupedItems[i] && groupedItems[i].length > 0" style="box-shadow: rgba(0, 0, 0, 0.03) 0px 8px 15px; margin: 0 -16px; padding-bottom: 0px; margin-bottom: 0px; overflow: hidden;">
                    <v-subheader @click="toggleGroupOpened(i)" :key="i" style="font-size: 15px; text-transform: none; margin: 0; padding-left: 16px; padding-right: 16px;" :class="countActiveItems(i) ? 'black--text text--darken-3' : 'grey--text'">
                        <span style="flex-grow: 1">{{ $t('plan_calculator.group_' + i) }}</span>
                        <!-- <span><v-icon style="margin: 0; border-radius: 16px; padding: 0; font-size: 30px;" v-text="groupOpened.includes(i) ? 'arrow_drop_up' : 'arrow_drop_down'"></v-icon></span> -->


                        <span v-if="['2','7','1','6'].includes(i)">
                            <span style="color: #1565c0; font-weight: 600; border: 2px solid #1565c0!important; border-radius: 16px; padding: 2px 10px; font-size: 11px; text-transform: none; display: inline-block; margin-top: 0px;" @click="$bus.$emit('pricelist:previewAnimation', getProtocolName(i))">
                                PLAY
                            </span>
                        </span>

                    </v-subheader>

                    <!-- <div style="font-size: 12px; line-height: 1.4; color: #aaa;">
                        {{$t(`protocol_descriptions.${['_','implant','bridge','temporary_bridge','_','_','one_phase_implants','veneer'][i]}`)}}
                    </div> -->

                    <div v-show="groupOpened.includes(i)" style="background: #fff; padding: 8px 16px;">
                        <template v-for="(state, n) in groupedItems[i]">
                            <pm-price-list-item
                                v-if="n < 300"
                                :key="n"
                                :idx="n"
                                :item="state"
                                @toggle="toggle(state)"
                                @focused="onFocus"
                                @blurred="onBlur"
                            />
                        </template>

                        <div
                            v-if="isTreatment(i)"
                            style="text-align: center; margin-top: 20px"
                            :id="`group_${i}`"
                        >
                            <v-btn
                                small
                                outline
                                flat
                                style="border-radius: 16px; border: 2px solid #2979ff !important; margin: 0; padding: 0 10px"
                                class="blue--text text--accent-3"
                                @click="addNewPriceListItem(i)"
                            >
                                <v-icon class="blue--text text--accent-3" v-text="'add'" /> {{ $t("plan_calculator.add_treatment") }}
                            </v-btn>
                        </div>

                        <div><br/></div>
                    </div>
                </div>
            </template>

            <template v-for="protocol in Object.keys($store.state.localSettings.protocols)">
                <pm-price-list-protocols
                    v-if="isVisible(protocol)"
                    :key="protocol"
                    :name="protocol"
                    @focused="onFocus"
                    @blurred="onBlur"
                    @save="save"
                />
            </template>

            <pm-preview-animation />

            <pm-price-list-form @save="onBlur" />
        </v-container>
        <pm-app-loading-content-indicator v-else />
    </pm-app-component>
</template>

<script>
import PmPriceListItem from "./pricelist-item";
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmPriceListProtocols from "./pricelist_protocols";
import protocols from "../../configs/protocols/protocols";
import PmPreviewAnimation from "./preview-animation";
import PmPriceListForm from "./pricelist-form.vue";

const extend = Object.assign;

/**
 * @typedef {object} Item
 * @property {string} status
 * @property {object} title
 * @property {object} price
 * @property {string} animate
 * @property {string} batch_price
 * @property {string} billable
 * @property {string} group
 * @property {string} id
 * @property {string} parent_id
 */

export default {
    mixins: [
        ToolbarMixin,
    ],
    components: {
        PmPreviewAnimation,
        PmPriceListItem,
        PmPriceListProtocols,
        PmPriceListForm,
    },
    toolbar: function() {
        const items = [
            {
                placeholder: true,
            },
            {
                key: "category",
                icon: "tick",
                iconClass: "app-back-button-icon",
                callback: () => {
                    // setUserProperty send log event too
                    // window.Tracker.logEvent({
                    //     event_name: "prices_set",
                    //     event_label: "prices",
                    // });

                    window.Tracker.setUserProperty("prices_set", 1, {
                        event_name: "prices_set",
                        event_label: "prices",
                        event_value: 1,
                    });

                    this.$router.push("/");
                },
            },
            {
                placeholder: true
            },
        ];

        return ([items]);
    },
    data: () => ({
        /** @type {Item[]} */
        groupedItems: [],
        activeInput: null,
        loading: true,
        groupOpened: ['1', '6', '2', '3', '7', '5'],
        cloudSaveRequired: false,
        timer: null,
    }),
    created() {
        this.groupedItems = this.$store.getters["smart/groupedTreatments"](true);

        try {
            if (localStorage.getItem('pricelistGroupOpened')) this.groupOpened = JSON.parse(localStorage.getItem('pricelistGroupOpened'));
        } catch(error) {
            captureException(error);
            this.groupOpened = ['1','6','2','3','7','5'];
        }
    },
    destroyed() {
        if (this.cloudSaveRequired) CloudSaveManager.saveSettings(this.$store.state.localSettings);
    },
    mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 500);
        localStorage.setItem('priceListVisited', true);
        this.$bus.$emit('mainMenu:update');
    },
    beforeDestroy() {

    },
    methods: {
        getProtocolName(id) {
            const map = new Map([
                ['2', 'bridge'],
                ['7', 'veneer'],
                ['1', 'bridge_implants'],
                ['6', 'bridge_implants_one_phase'],
            ]);
            return map.get(id);
        },
        /**
         *
         * @param {string} index
         * @return {boolean}
         */
        isTreatment(index) {
            const {min, max} = {min: 5000, max: 6000};
            const isTreatment = (id) => id >= min && id < max;

            return this.groupedItems[index].map(({id}) => id).every(isTreatment);
        },
        /**
         *
         * @param {string} index
         * @return {void}
         */
        async addNewPriceListItem(index) {
            // Get the maximum id of items.
            const maxId = Math.max(...this.groupedItems[index].map(({id}) => id), 0);
            const {currency, language} = this.$store.state;
            const defaultPrice = {[currency]: "0"};
            const defaultTitle = {[language]: ""};
            // Increment id of last item. View is filtered by `treatment.id`.
            const lastId = String(maxId + 1);

            /** @type {Item} */
            const item = {
                animate: "1",
                batch_price: "0",
                billable: "1",
                group: "5",
                id: lastId,
                parent_id: "",
                status: "1",
                price: extend(defaultPrice),
                title: extend(defaultTitle),
            };

            // Add item to reactive state.
            this.groupedItems[index].push(item);

            await this.$nextTick();

            // Focus the last added input element.
            const inputList = document.querySelector("#group_5").parentNode.querySelectorAll("input");

            if (inputList && inputList[inputList.length - 2]) inputList[inputList.length - 2].focus();

            // Ad item to store. It will be saved into `localStorage`.
            this.$store.state.localSettings.dentalStates[item.id] = item;
        },
        isVisible(protocol) {
            if (protocol === 'fast_and_fixed_4' && localStorage.getItem('dc_free_treatment_fast_and_fixed') !== 'true') return false;
            if (protocol === 'fast_and_fixed_6' && localStorage.getItem('dc_free_treatment_fast_and_fixed') !== 'true') return false;
            return this.$store.state.localSettings.protocols[protocol].full_jaw === 1;
        },
        toggleGroupOpened(i) {
            const idx = this.groupOpened.indexOf(i);
            // if (idx === -1) this.groupOpened.push(i);
            // else this.groupOpened.splice(idx, 1);
            if (idx === -1) this.groupOpened.push(i);
            localStorage.setItem('pricelistGroupOpened', JSON.stringify(this.groupOpened));


        },
        previewAnimation(items) {
            let name = "";
            if (items[0].parent_id === '11') name = 'bridge_implants';
            if (items[0].parent_id === '10') name = 'bridge_implants_one_phase';
            if (items[0].parent_id === '15') name = 'bridge';
            if (items[0].parent_id === '26') name = 'veneer';
            if (name !== "") this.$bus.$emit('pricelist:previewAnimation', name);
        },
        ensureNewTreatmentNameForOtherLanguages() {
            const languages = Object.keys(this.$store.state.localSettings.languages);
            const protocolNames = Object.keys(this.$store.state.localSettings.protocols);

            protocolNames.forEach((protocolName) => {
                const protocol = this.$store.state.localSettings.protocols[protocolName];

                if (Array.isArray(protocol.variation_titles)) {
                    const titlesShouldBeTranslate = [];

                    protocol.variation_titles.forEach((title) => {
                        const titleLanguageKeys = Object.keys(title);

                        // Every keys existing.
                        if (languages.length === titleLanguageKeys.length) {
                            titleLanguageKeys.forEach((language) => {
                                if (title[language] === "") {
                                    if (!titlesShouldBeTranslate.includes(protocolName)) {
                                        titlesShouldBeTranslate.push(protocolName);
                                    }
                                }
                            });
                        }
                    });

                    // No translatable found.
                    if (!titlesShouldBeTranslate.length) {
                        return;
                    }

                    protocol.variation_titles.forEach((title) => {
                        if (titlesShouldBeTranslate.includes(protocolName)) {
                            languages.forEach((language) => {
                                if (title[language] === "") {
                                    title[language] = title[this.$store.state.language];
                                }
                            });
                        }
                    });
                }
            });
        },
        async save() {
            this.cloudSaveRequired = true;

            localStorage.setItem("settings", JSON.stringify(this.$store.state.localSettings));
            localStorage.setItem("demoPrices", "false");

            this.ensureNewTreatmentNameForOtherLanguages();

            await this.$nextTick();

            window.Tracker.logEvent({
                event_name: "pricelist_save",
                event_category: "pricelist",
                event_label: "Save prices",
            });
        },
        toggle(item) {
            const dentalstateMap = {
                veneer: [7],
                crown_implants: [1, 2],
                bridge_implants: [1, 2],
                crown: [2],
                bridge: [2],
                bridge_implants_one_phase: [2, 6],
                crown_implants_one_phase: [2, 6],
            };

            Object.keys(dentalstateMap).forEach((protocolName) => {
                const ids = dentalstateMap[protocolName];

                if (!ids.includes(parseInt(item.group))) return;
                let status = 1;

                ids.forEach((id) => {
                    if (!this.countActiveItems(id)) status = 0;
                });

                this.$store.state.localSettings.protocols[protocolName].active = status;
            });

            if(item.group === "5") {
                const titles = Object.values(item.title).filter((el)=>el.length > 0);
                const prices = Object.values(item.price).filter((el)=>el!==null && parseInt(el) > 0);
                if (titles.length === 0 && prices.length === 0) {
                    delete this.$store.state.dentalStates[item.id];
                    this.groupedItems = this.$store.getters["smart/groupedTreatments"](true);
                }
            }

            this.save();
        },
        countActiveItems(groupId) {
            let counter = 0;
            Object.keys(this.$store.state.dentalStates).forEach((id) => {
                const item = this.$store.state.dentalStates[id];
                if (item.group == groupId && item.status == "1") {
                    counter++;
                }
            });
            return counter;
        },
        onFocus($event) {
            this.activeInput = true;
        },
        onBlur() {
            this.save();
        },
    },
};
</script>
